import Preact from "preact";

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: "required", message: "Please complete this required field." }
      ]
    },
    lastName: {
      validations: []
    },
    email: {
      validations: [
        { type: "required", message: "Please complete this required field." },
        {
          type: "regex",
          pattern:
            "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?",
          message: "Please provide a valid email."
        }
      ]
    },
    telNumber: {
      validations: [
        { type: "required", message: "Please complete this required field." },
        {
          type: "regex",
          pattern:
            "[(]{0,1}[0-9]{3}[) ]{0,2}[-s.]{0,1}[0-9]{3}[-s.]{0,1}[0-9]{4}",
          message: "Please provide a valid phone number."
        }
      ]
    },
    clientname: {
      validations: []
    },
    addressline1: {
      validations: [
        { type: "required", message: "Please complete this required field." }
      ]
    },
    city: {
      validations: []
    },
    state: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: "required", message: "Please complete this required field." },
        { type: "dateinfuture", message: "Event date must be in the future." }
      ]
    },
    accountextra1: {
      validations: [
        {
          type: "required",
          message: "Please select an option from the dropdown menu."
        }
      ]
    },
    eventextra1: {
      validations: [
        { type: "required", message: "Please complete this required field." }
      ]
    },
    accountextra2: {
      validations: [
        { type: "required", message: "Please select at least one option." }
      ]
    },
    accountextra4: {
      validations: [
        {
          type: "required",
          message: "Please select an option from the dropdown menu."
        }
      ]
    },
    reference: {
      validations: [
        { type: "required", message: "Please complete all required fields." }
      ]
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: "text",
            size: "Medium",
            label: "First name:*",
            mapping: "firstName"
          },
          {
            type: "text",
            size: "Medium",
            label: "Last name:",
            mapping: "lastName"
          }
        ]
      },
      {
        fields: [
          {
            type: "text",
            size: "Medium",
            label: "Email:*",
            mapping: "email"
          }
        ]
      },
      {
        fields: [
          {
            type: "text",
            size: "Medium",
            label: "Phone number:*",
            mapping: "telNumber"
          }
        ]
      },
      {
        fields: [
          {
            type: "text",
            size: "Medium",
            label: "Company name:",
            mapping: "clientname"
          }
        ]
      },
      {
        fields: [
          {
            type: "text",
            size: "Medium",
            label: "Street address:*",
            mapping: "addressline1"
          },
          {
            type: "text",
            size: "Medium",
            label: "City:",
            mapping: "city"
          },
          {
            type: "text",
            size: "Medium",
            label: "State/Region:",
            mapping: "state"
          }
        ]
      },
      {
        fields: [
          {
            type: "date-picker",
            size: "Medium",
            label: "Desired Date of Event:*",
            mapping: "eventDate"
          }
        ]
      },
      {
        fields: [
          {
            type: "multiple-choice",
            size: "Medium",
            label: "Is this the only date available for the event?:*",
            options: [
              { label: "Yes", value: "Yes" },
              { label: "No", value: "No" }
            ],
            mapping: "accountextra1"
          }
        ]
      },
      
      {
        fields: [
          {
            type: "text",
            size: "Medium",
            label: "Estimate Number of Guests:*",
            mapping: "eventextra1"
          }
        ]
      },
      {
        fields: [
          {
            type: "checkbox-list",
            size: "Medium",
            label: "Desired Time of Event:*",
            options: [
              { label: "Day", value: "Day" },
              { label: "Night", value: "Night" }
            ],
            mapping: "accountextra2"
          }
        ]
      },
      {
        fields: [
          {
            type: "multiple-choice",
            size: "Medium",
            label: "Occasion:*",
            options: [
              { label: "Bar Mitzvah", value: "Bar Mitzvah" },
              { label: "Bat Mitzvah", value: "Bat Mitzvah" },
              { label: "Kosher Bar Mitzvah", value: "Kosher Bar Mitzvah" },
              { label: "Kosher Bat Mitzvah", value: "Kosher Bat Mitzvah" },
              { label: "Sweet 16", value: "Sweet 16" },
              { label: "Milestone Birthday", value: "Milestone Birthday" },
              { label: "Seasonal Weddings", value: "Seasonal Weddings" },
              { label: "Engagement Party", value: "Engagement Party" },
              { label: "Holiday Party", value: "Holiday Party" },
              { label: "Corporate Party", value: "Corporate Party" },
            ],
            mapping: "accountextra4"
          }
        ]
      },
      {
        fields: [
          {
            type: "multiple-choice",
            size: "Medium",
            label: "How Did You Hear About Us?:*",
            options: [
              { label: "Family or Friend", value: "Family or Friend" },
              { label: "Facebook", value: "Facebook" },
              { label: "Instagram", value: "Instagram" },
              { label: "News/Media", value: "News/Media" },
              { label: "Online", value: "Online" },
              {
                label: "Tri State Restaurant Club",
                value: "Tri State Restaurant Club"
              },
              { label: "Other", value: "Other" }
            ],
            mapping: "reference"
          }
        ]
      },
      {
        fields: [
          {
            type: "submit",
            size: "XLarge",
            label: "Submit"
          }
        ]
      }
    ]
  },
  info: {
    title: "Vienna of Roslyn Social Event Form",
    formId: "371",
    clientKey: "556959E7-4F59-4437-AC6D-4741A0C047D6",
    appKey: "23697F14-AA8C-4622-9F64-FC1A9FF20D0D",
    redirectUrl: "https://viennaofroslyn.com/thank-you/",
    submissionText:
      "Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.",
    apiEndpoint: "//api-cec.catereasewebtools.com/inbound-inquiries"
  }
};

export default FormStructure;
